import { render, staticRenderFns } from "./XmMoreSelect.vue?vue&type=template&id=ff949f1a&scoped=true"
import script from "./XmMoreSelect.vue?vue&type=script&lang=js"
export * from "./XmMoreSelect.vue?vue&type=script&lang=js"
import style0 from "./XmMoreSelect.vue?vue&type=style&index=0&id=ff949f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff949f1a",
  null
  
)

export default component.exports